import { render, staticRenderFns } from "./BadgeUsersFilter.vue?vue&type=template&id=03af1d37&scoped=true"
import script from "./BadgeUsersFilter.vue?vue&type=script&lang=js"
export * from "./BadgeUsersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03af1d37",
  null
  
)

export default component.exports